import * as React from 'react'
import {
  WithStyles,
  Grid,
  Button,
  Select,
  MenuItem,
  createStyles,
  InputLabel,
  ListItemText,
  FormControl,
  FormHelperText
} from '@material-ui/core'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import withStyles from '@material-ui/core/styles/withStyles'
import ordinal from 'ordinal'

import IContest, { ICompetitorLevel } from 'src/models/IContest'

interface IDivisionSelectionProps extends WithStyles<typeof styles> {
  onChange: (divisions: string[]) => void
  selectedLevel: ICompetitorLevel
  selectedDivisions: string[]
  contest: IContest
}

class DivisionSelection extends React.PureComponent<IDivisionSelectionProps> {
  public render() {
    const { classes, selectedDivisions, selectedLevel } = this.props
    const divisions = selectedLevel.divisions

    return (
      <>
        {selectedDivisions.map((selectedDivision, i) => (
          <React.Fragment key={i}>
            <Grid item xs={selectedLevel.crossoverFee ? 7 : 12}>
              <FormControl fullWidth required>
                <InputLabel htmlFor={`divisions[${i}]`}>
                  {selectedDivisions.length === 1
                    ? 'Division'
                    : `${ordinal(i + 1)} Division`}
                </InputLabel>
                <Select
                  renderValue={this.renderValue}
                  name={`divisions[${i}]`}
                  onChange={this.updateDivision}
                  required
                  value={selectedDivision}>
                  {divisions.reduce<React.ReactNode[]>(
                    (menuItems, division) => {
                      const item = (
                        <MenuItem
                          key={division.name}
                          value={division.name}
                          disabled={division.subDivisions.length > 0}
                          className={
                            division.subDivisions.length > 0
                              ? classes.group
                              : ''
                          }>
                          {division.name}
                        </MenuItem>
                      )
                      return menuItems.concat(item).concat(
                        division.subDivisions.map(subDivision => (
                          <MenuItem
                            key={`${division.name}-${subDivision}`}
                            value={`${division.name}, ${subDivision}`}
                            className={classes.item}>
                            <ListItemText primary={subDivision} />
                          </MenuItem>
                        ))
                      )
                    },
                    []
                  )}
                </Select>
                {selectedLevel.note && (
                  <FormHelperText>{selectedLevel.note}</FormHelperText>
                )}
              </FormControl>
            </Grid>

            {selectedLevel.crossoverFee && (
              <Grid item xs={5}>
                <FormControl fullWidth>
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={i === 0 && selectedDivisions.length >= 5}
                    onClick={this.addOrRemoveDivision.bind(this, i)}
                    fullWidth>
                    {i > 0
                      ? 'Remove division'
                      : `Add division +$${selectedLevel.crossoverFee}`}
                  </Button>
                </FormControl>
              </Grid>
            )}
          </React.Fragment>
        ))}
      </>
    )
  }

  private renderValue = (value: string) => value

  private updateDivision = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target
    const index = +(name.match(/\d+/) || '-1')

    const { selectedDivisions } = this.props

    const newDivisions = [
      ...selectedDivisions.slice(0, index),
      value,
      ...selectedDivisions.slice(index + 1)
    ]

    this.props.onChange(newDivisions)
  }

  private addOrRemoveDivision = (index: number) => {
    let { selectedDivisions } = this.props

    if (index === 0) {
      selectedDivisions = selectedDivisions.concat([''])
    } else {
      selectedDivisions = selectedDivisions.filter((d, i) => i !== index)
    }
    this.props.onChange(selectedDivisions)
  }
}

const styles = (theme: Theme) =>
  createStyles({
    item: {
      paddingLeft: 3 * theme.spacing.unit
    },
    group: {
      fontWeight: theme.typography.fontWeightMedium,
      opacity: 1
    }
  })

export default withStyles(styles)(DivisionSelection)



// WEBPACK FOOTER //
// ./src/components/contest/DivisionSelection.tsx